import clsx from 'clsx';
import { TooltipRenderProps } from 'react-joyride';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useMouseDetect } from 'shared/lib/utils';
import { NextButton, OvalButton } from 'shared/ui/buttons';
import { Tooltip } from 'shared/ui/tooltip';

import { ProgressBar } from '../progress-bar';

import styles from './styles.module.scss';

export const WalkthroughTooltip = ({
  index,
  step,
  size,
  primaryProps,
  tooltipProps,
  skipProps,
  backProps,
}: TooltipRenderProps) => {
  const { t } = useTranslation();

  const tooltipRef = useRef<HTMLDivElement>(null);

  useMouseDetect(tooltipRef);

  return (
    <div {...tooltipProps}>
      <div className={styles.tooltip} ref={tooltipRef}>
        <Tooltip
          title={t('Close')}
          wrapperClassNames={styles.closeButtonContainer}
        >
          <button
            type="button"
            className={clsx('btn btn-icon-ghost', styles.closeButton)}
            onClick={skipProps.onClick}
            aria-label="Close walkthrough"
          >
            <i className="icon-v2-close" aria-hidden />
          </button>
        </Tooltip>
        <p className={styles.content}>{step.content}</p>
        {index === size - 1 ? (
          <OvalButton
            onClick={primaryProps.onClick}
            classNames={styles.button}
            ariaLabel="Done"
          >
            {t('Done')}
          </OvalButton>
        ) : (
          <NextButton
            onClick={primaryProps.onClick}
            text={t('Next')}
            classNames={styles.button}
            ariaLabel="Walkthrough progress"
          />
        )}
        <ProgressBar
          activeIndex={index}
          classNames={styles.progressBar}
          onBackButtonClick={backProps.onClick}
        />
      </div>
    </div>
  );
};
